{
  "meta": {
    "title":       "İletişim | GlobalAnka",
    "description": "GlobalAnka ile iletişime geçin. Kurumsal teklif talepleriniz ve B2B iş birliği görüşmeleri için bizimle ulaşın."
  },
  "hero": {
    "tagLabel":     "İletişim",
    "titleStart":   "Stratejik",
    "titleAccent":  "İş Ortaklığı",
    "titleEnd":     "İçin İlk Adım",
    "subtitle":     "GlobalAnka olarak kurumsal ihtiyaçlarınıza özel çözümler üretiyoruz. Teklif talepleriniz ve B2B iş birliği görüşmeleri için formumuzu doldurun."
  },
  "info": {
    "headquartersLabel": "Genel Merkez",
    "emailLabel":        "E-Posta",
    "phoneLabel":        "Telefon",
    "mapPlaceholder":    "Levent Plaza — Google Maps",
    "mapEmbedUrl":       "",
    "mapIframeTitle":    "Konum haritası",
    "rows": [
      {
        "icon": "building",
        "label": "Genel Merkez",
        "value": "Levent Plaza, Büyükdere Cad. No:173, Şişli, İstanbul",
        "href": ""
      },
      {
        "icon": "envelope",
        "label": "E-Posta",
        "value": "kurumsal@globalanka.com",
        "href": "mailto:kurumsal@globalanka.com"
      },
      {
        "icon": "phone",
        "label": "Telefon",
        "value": "+90 (212) 555 01 99",
        "href": "tel:+902125550199"
      }
    ]
  },
  "form": {
    "title": "Kurumsal Teklif Formu",
    "fields": [
      {
        "id": "companyName",
        "type": "text",
        "label": "Şirket Adı",
        "placeholder": "Örn: Anka Holding A.Ş.",
        "required": true,
        "width": "half",
        "options": []
      },
      {
        "id": "sector",
        "type": "select",
        "label": "Sektör",
        "placeholder": "Sektörünüzü seçin",
        "required": true,
        "width": "half",
        "options": [
          { "value": "Tourism", "label": "Turizm" },
          { "value": "Construction", "label": "İnşaat" },
          { "value": "Health", "label": "Sağlık" },
          { "value": "Other", "label": "Diğer" }
        ]
      },
      {
        "id": "employeeCount",
        "type": "select",
        "label": "Çalışan Sayısı",
        "placeholder": "Aralık seçin",
        "required": true,
        "width": "half",
        "options": [
          { "value": "1-10", "label": "1 – 10" },
          { "value": "11-50", "label": "11 – 50" },
          { "value": "51-200", "label": "51 – 200" },
          { "value": "201-500", "label": "201 – 500" },
          { "value": "500+", "label": "500+" }
        ]
      },
      {
        "id": "email",
        "type": "email",
        "label": "E-Posta (Kurumsal)",
        "placeholder": "kurumsal@sirketiniz.com",
        "required": true,
        "width": "half",
        "options": []
      },
      {
        "id": "phone",
        "type": "tel",
        "label": "Telefon (Opsiyonel)",
        "placeholder": "+90 5XX XXX XX XX",
        "required": false,
        "width": "full",
        "options": []
      },
      {
        "id": "message",
        "type": "textarea",
        "label": "Mesajınız",
        "placeholder": "Projeniz veya ihtiyaçlarınız hakkında kısa bir bilgi verin...",
        "required": false,
        "width": "full",
        "options": []
      }
    ]
  }
}
